import { SharingDebitProjectResponse } from '@/app/models/sharingDetails';
import formatterMonetaryValue from '@/app/utils/numberUtils';
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.grey[200],
}));

const RowTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  padding: theme.spacing(1),
}));

type RuleClassificationTableGridParams = {
  rows: SharingDebitProjectResponse[];
};

function SharingTableHeader(params: RuleClassificationTableGridParams) {
  const { t } = useTranslation('sharingDetails');

  const { rows } = params;
  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell>{t('project')}</HeaderTableCell>
            <HeaderTableCell>{t('total.paid')}</HeaderTableCell>
            <HeaderTableCell />
            <HeaderTableCell />
          </TableRow>
        </TableHead>
      </Table>
      <Table
        sx={{
          tableLayout: 'fixed',
          width: '100%',
          fontSize: '16px',
        }}
      >
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.debitProjectCode}>
              <RowTableCell>{`${row.debitProjectCode} - ${row.debitProjectName}`}</RowTableCell>
              <RowTableCell>{formatterMonetaryValue(row.value)}</RowTableCell>
              <RowTableCell />
              <RowTableCell />
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={2}>
                <Typography variant="subtitle2">{t('no.data.found')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SharingTableHeader;
